import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #cecece;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
  cursor: pointer;
  border-radius: 8px;
`;

export const ListThumbs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  flex-wrap: wrap;
  margin: 25px 0 0 0;
`

export const ThumbsContainer = styled.div`
  width: calc(33.33333333333333% - 40px);
`

export const Thumb = styled.div`
  
`

export const ThumbInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

export const Img = styled.div`
  width: 64px;
  height: 64px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
  min-width: 64px;

  .btn-remove-attach {
    background: var(--red);
    padding: 0;
    min-width: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    position: absolute;
    top: -8px;
    right: -8px;
    border: 2px solid var(--white);
    -webkit-box-shadow: 0px 0px 9px -3px rgba(0,0,0,0.76);
    -moz-box-shadow: 0px 0px 9px -3px rgba(0,0,0,0.76);
    box-shadow: 0px 0px 9px -3px rgba(0,0,0,0.76);
    cursor: pointer;

    svg {
      font-size: 16px;
      color: var(--white);
    }
  }
`
export const DadosAnexo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 10px;
  width: 100%;

  .btn-remove-attach {
    min-width: 32px;
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    color: var(--red);
  }
`

DadosAnexo.Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

DadosAnexo.Nome = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 13px;
  max-width: 220px;
`

DadosAnexo.Tamanho = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-size: 12px;
`